import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { usePenelopeAccess } from '@/hooks/usePenelopeAccess';
import { canAccessPenelope, type Role } from '@/types/navigation';

/** Direct /penelope URLs use the same predicate as the navigation registry:
 * admin/manager always, traders only with the resolved `penelopeAccess` grant.
 * Revoking the grant rerenders this guard and ejects an open panel. */
export function PenelopeRoute() {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  const penelopeAccess = usePenelopeAccess();
  return canAccessPenelope(role, penelopeAccess) ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
